const initialState = () => ({
  strategiesInfo: {
    pagination: {},
    items: [],
  },
  templatesWhatsapp: [],
  activeUsers: [],
  agents: [],
  emailChannel: {},
  filteredActiveUsers: [],
  selectedActiveUsersId: [],
  rescheduleStrategyModal: { show: false, data: null },
});

const state = initialState();

export default state;
